import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { IoSendSharp } from "react-icons/io5";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import image from "../Assets/profile-banner.jpg";
import image2 from "../Assets/dos_donts.png";
import side_image from "../Assets/side_image.jpg";
import side_image2 from "../Assets/cc-middle.jpg";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CrackersLoader from './CrackersLoader';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import Sticker from "./Sticker";
import MobileNavigation from "./MobileNavigation";
import "./home.css";
import category_img from "../Assets/category-default.png"

const Home = () => {
  const [isChatBoxVisible, setChatBoxVisible] = useState(false);
  const [showDos, setShowDos] = useState(true);
  const [categories, setCategories] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  const [marqueeText, setMarqueeText] = useState([]);
  const [message, setMessage] = useState("");
  const [homeData, setHomeData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [gallery, setGallery] = useState([]);
  const [clientlogo, setClientLogo] = useState([]);
  const navigate = useNavigate();
  
  const toggleChatBox = () => {
    setChatBoxVisible(!isChatBoxVisible);
  };
  
  function getCategoryColor(index) {
    const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57'];
    return colors[index % colors.length];
  }
  
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const sendMessage = () => {
    if (!whatsappNumber) {
      console.log("WhatsApp number is not available yet");
      return;
    }

    const whatsappUrl = `https://wa.me/${whatsappNumber.replace("+", "")}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}home.php`);
        const { body } = response.data;
        setCategories(body?.category_front || []);
        setCarouselImages(body?.banner || []);
        setMarqueeText(body?.scrollnew?.map(item => item.msg) || []);
        setGallery(body?.gallery || []);
        setClientLogo(body?.client_logo || []);
      } catch (error) {
        console.error("There was an error fetching the data!", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();   
  }, []);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { body } = response.data;
        const { whatsapp_number } = response.data.body.contact;
        setHomeData(body.home);
        setWhatsappNumber(whatsapp_number);
      } catch (error) {
        console.error("Error fetching the about data", error);
      }
    };
    fetchHomeData();
  }, []);

  if (isLoading) {
    return <CrackersLoader />;
  }

  if (!homeData) {
    return <p> </p>;
  }
  
  const handleCategoryClick = (category) => {
    navigate('/quick', { state: { selectedCategory: category.category_name } });
  };

  return (
    <div className="home-main-container">
      <Header />

      {/* Carousel Section */}
      <div className="home-carousel-container">
        <Carousel className="home-carousel" interval={3000}>
          {carouselImages.map(({ id, image }) => (
            <Carousel.Item key={id}>
              <img
                className="d-block w-100"
                src={image}
                alt="Carousel slide"
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {/* Marquee Section */}
      <div className="home-marquee-container">
        <div className="home-marquee-content">
          <p>{marqueeText}</p>
        </div>
      </div>

      {/* Welcome Section */}
      <div className="home-welcome-section">
        <div className="home-welcome-container">
          {/* Image Section */}
          <div className="home-welcome-image-wrapper">
            <div className="home-shape-container">
              <div className="home-shape-frame">
                <div className="home-shape-inner">
                  <img 
                    src={side_image} 
                    alt="Sun Pyro Kart" 
                    className="home-featured-image"
                  />
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="home-decorative-corner home-corner-top-left">
                <div className="home-corner-dot"></div>
                <div className="home-corner-line"></div>
              </div>
              <div className="home-decorative-corner home-corner-top-right">
                <div className="home-corner-dot"></div>
                <div className="home-corner-line"></div>
              </div>
              <div className="home-decorative-corner home-corner-bottom-left">
                <div className="home-corner-dot"></div>
                <div className="home-corner-line"></div>
              </div>
              <div className="home-decorative-corner home-corner-bottom-right">
                <div className="home-corner-dot"></div>
                <div className="home-corner-line"></div>
              </div>
              
              {/* Floating Elements */}
              <div className="home-floating-element home-circle-1"></div>
              <div className="home-floating-element home-circle-2"></div>
              <div className="home-floating-element home-triangle"></div>
            </div>
          </div>
          
          {/* Content Section */}
          <div className="home-welcome-content">
            <div className="home-welcome-header">
              <h2 className="home-welcome-subtitle">Welcome To</h2>
              <h1 className="home-welcome-title">
                <span className="home-brand-accent">SUN</span>
                <span className="home-brand-name">PYRO KART</span>
                
              </h1>
              <p className="home-welcome-tagline">
                Wholesale & Retail Shop in <strong>SIVAKASI</strong>
              </p>
            </div>
            
            <div className="home-welcome-description">
              <span dangerouslySetInnerHTML={{ __html: homeData.value }} />
            </div>
            
            <div className="home-features-grid">
              <span className="home-feature-item">
                <div className="home-feature-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <span className="home-feature-text">Premium Quality</span>
              </span>
              <span className="home-feature-item">
                <div className="home-feature-icon">
                  <i className="fas fa-truck"></i>
                </div>
                <span className="home-feature-text">Timely Delivery</span>
              </span>
              <span className="home-feature-item">
                <div className="home-feature-icon">
                  <i className="fas fa-tag"></i>
                </div>
                <span className="home-feature-text">Best Prices</span>
              </span>
            </div>
            
            {/* Decorative Line */}
            <div className="home-decorative-line">
              <div className="home-line-dot"></div>
              <div className="home-line-dot"></div>
              <div className="home-line-dot"></div>
            </div>
          </div>
        </div>
      </div>
      
      <Sticker />

      {/* Categories Section */}
      <div className="home-categories-section">
        <div className="home-categories-header">
          <h2 className="home-categories-title">Our Top Categories</h2>
          <p className="home-categories-subtitle">Browse our curated collections</p>
        </div>

        <div className="home-categories-grid">
          {categories.map((category, index) => (
            <div
              key={category.category_id}
              className="home-category-card"
              onClick={() => handleCategoryClick(category)}
              style={{ 
                cursor: "pointer", 
                animationDelay: `${index * 0.08}s`,
                '--hover-color': getCategoryColor(index)
              }}
            >
              
              <div className="home-category-image">
                <img
                  src={category.image || category_img}
                  alt={category.category_name}
                  loading="lazy"
                />
              </div>

              <div className="home-category-info">
                <h5 className="home-category-name">{category.category_name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Estimate Section */}
      <div className="home-estimate-section">
        <div className="home-estimate-container">
          {/* Left Image with Curved Shape */}
          <div className="home-estimate-image-section">
            <div className="home-estimate-image-wrapper">
              <div className="home-estimate-curved-shape">
                <div className="topimg">
                  <img 
                    src={side_image2} 
                    alt="Sivakasi Crackers" 
                    className="home-estimate-image"
                  />
                </div>
              </div>
              <div className="home-estimate-shape-decoration home-shape-1"></div>
              <div className="home-estimate-shape-decoration home-shape-2"></div>
              <div className="home-estimate-shape-decoration home-shape-3"></div>
            </div>
          </div>
          
          {/* Right Content */}
          <div className="home-estimate-content-section">
            <div className="home-estimate-content-card">
              <span className="home-estimate-badge">
                <i className="fas fa-bolt"></i> Instant Quote
              </span>
              <h1 className="home-estimate-heading">
                Get Your Crackers Estimate
                In Minutes
              </h1>
              <p className="home-estimate-description">
                Our online estimator helps you plan your budget for Diwali, weddings, 
                and other celebrations with transparent pricing.
              </p>
              <Link to="/quick" className="home-estimate-button">
                <span>Get Free Estimate</span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="home-section-divider">
        <hr className="home-divider-line" />
        <h4 className="home-divider-text">Gallery</h4>
        <hr className="home-divider-line" />
      </div>

      <div className="home-gallery-container">
        <Swiper
          slidesPerView={4}
          spaceBetween={10}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 10 },
            480: { slidesPerView: 2, spaceBetween: 10 },
            768: { slidesPerView: 3, spaceBetween: 10 },
            1024: { slidesPerView: 4, spaceBetween: 10 },
          }}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
          className="home-gallery-swiper"
        >
          {gallery.map((logo, index) => (
            <SwiperSlide key={index} className="home-gallery-slide">
              <div className="home-gallery-card">
                <img src={logo.image} alt={`Gallery ${index}`} className="home-gallery-image" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Safety Tips Section with Image */}

{/* Safety Tips Section with Image */}
<div className="home-safety-section">
  <div className="home-safety-container">
    <div className="home-safety-content-wrapper">
      {/* Left Side - Do's & Don'ts */}
      <div className="home-safety-tab-section">
        {/* Mobile Tabs - Only visible on mobile */}
        <div className="home-safety-mobile-tabs">
          <button 
            className={`home-safety-tab-btn ${showDos ? 'active' : ''}`}
            onClick={() => setShowDos(true)}
          >
            <i className="fas fa-check-circle"></i> Do's
          </button>
          <button 
            className={`home-safety-tab-btn ${!showDos ? 'active' : ''}`}
            onClick={() => setShowDos(false)}
          >
            <i className="fas fa-times-circle"></i> Don'ts
          </button>
        </div>

        <div className="home-safety-content">
          {/* Mobile View - Tab Content */}
          <div className="home-safety-mobile-view">
            {showDos ? (
              <div className="home-safety-dos-card mobile-view">
                <div className="home-safety-card-header">
                  <div className="home-safety-card-icon">
                    <i className="fas fa-thumbs-up"></i>
                  </div>
                  <h3>Safety Do's</h3>
                </div>
                <div className="home-safety-card-body">
                  <div className="home-safety-points-list">
                    <div className="home-safety-point-item home-dos-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-store"></i>
                      </span>
                      <span>Buy from licensed dealers only</span>
                    </div>
                    <div className="home-safety-point-item home-dos-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-fire-extinguisher"></i>
                      </span>
                      <span>Keep safety equipment ready</span>
                    </div>
                    <div className="home-safety-point-item home-dos-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-trash"></i>
                      </span>
                      <span>Discard used fireworks in water</span>
                    </div>
                    <div className="home-safety-point-item home-dos-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-user-shield"></i>
                      </span>
                      <span>Adult supervision for children</span>
                    </div>
                    <div className="home-safety-point-item home-dos-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-book"></i>
                      </span>
                      <span>Read and follow instructions</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="home-safety-donts-card mobile-view">
                <div className="home-safety-card-header">
                  <div className="home-safety-card-icon">
                    <i className="fas fa-ban"></i>
                  </div>
                  <h3>Safety Don'ts</h3>
                </div>
                <div className="home-safety-card-body">
                  <div className="home-safety-points-list">
                    <div className="home-safety-point-item home-donts-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-child"></i>
                      </span>
                      <span>Don't let children play alone</span>
                    </div>
                    <div className="home-safety-point-item home-donts-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-tshirt"></i>
                      </span>
                      <span>Avoid synthetic/loose clothing</span>
                    </div>
                    <div className="home-safety-point-item home-donts-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-hand-paper"></i>
                      </span>
                      <span>Never hold crackers in hand</span>
                    </div>
                    <div className="home-safety-point-item home-donts-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-fire"></i>
                      </span>
                      <span>Keep away from open flames</span>
                    </div>
                    <div className="home-safety-point-item home-donts-item">
                      <span className="home-safety-point-icon">
                        <i className="fas fa-ban"></i>
                      </span>
                      <span>Avoid crowded areas</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Desktop View - Side by Side */}
          <div className="home-safety-desktop-view">
            <div className="home-safety-card home-safety-dos-card">
              <div className="home-safety-card-header">
                <div className="home-safety-card-icon">
                  <i className="fas fa-thumbs-up"></i>
                </div>
                <h3>Safety Do's & Don'ts</h3>
              </div>
              <div className="home-safety-card-body">
                <div className="home-safety-comparison">
                  <div className="home-safety-dos-column">
                    <h4 className="home-safety-column-title">
                      <i className="fas fa-check text-success"></i> DO'S
                    </h4>
                    <div className="home-safety-points-list">
                      <div className="home-safety-point-item home-dos-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-store"></i>
                        </span>
                        <span>Buy from licensed dealers only</span>
                      </div>
                      <div className="home-safety-point-item home-dos-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-fire-extinguisher"></i>
                        </span>
                        <span>Keep safety equipment ready</span>
                      </div>
                      <div className="home-safety-point-item home-dos-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-trash"></i>
                        </span>
                        <span>Discard used fireworks in water</span>
                      </div>
                      <div className="home-safety-point-item home-dos-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-user-shield"></i>
                        </span>
                        <span>Adult supervision for children</span>
                      </div>
                      <div className="home-safety-point-item home-dos-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-book"></i>
                        </span>
                        <span>Read and follow instructions</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="home-safety-divider">
                    <div className="home-safety-divider-line"></div>
                    <div className="home-safety-divider-text">VS</div>
                    <div className="home-safety-divider-line"></div>
                  </div>
                  
                  <div className="home-safety-donts-column">
                    <h4 className="home-safety-column-title">
                      <i className="fas fa-times text-danger"></i> DON'TS
                    </h4>
                    <div className="home-safety-points-list">
                      <div className="home-safety-point-item home-donts-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-child"></i>
                        </span>
                        <span>Don't let children play alone</span>
                      </div>
                      <div className="home-safety-point-item home-donts-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-tshirt"></i>
                        </span>
                        <span>Avoid synthetic/loose clothing</span>
                      </div>
                      <div className="home-safety-point-item home-donts-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-hand-paper"></i>
                        </span>
                        <span>Never hold crackers in hand</span>
                      </div>
                      <div className="home-safety-point-item home-donts-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-fire"></i>
                        </span>
                        <span>Keep away from open flames</span>
                      </div>
                      <div className="home-safety-point-item home-donts-item">
                        <span className="home-safety-point-icon">
                          <i className="fas fa-ban"></i>
                        </span>
                        <span>Avoid crowded areas</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Image Only */}
      <div className="home-safety-image-section">
        <div className="home-safety-image-card">
          <div className="home-safety-image-container">
            <img 
              src={image2} 
              alt="Safety Do's and Don'ts" 
              className="home-safety-image"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="home-safety-footer">
      <div className="home-safety-note">
        <i className="fas fa-exclamation-triangle"></i>
        <span>Remember: Celebrate responsibly with safety first!</span>
      </div>
    </div>
  </div>
</div>

      {/* Brands Section */}
      <div className="home-section-divider">
        <hr className="home-divider-line" />
        <h4 className="home-divider-text">Brands</h4>
        <hr className="home-divider-line" />
      </div>
      
      <div className="home-brands-section">
        <Swiper
          slidesPerView={6}
          spaceBetween={20}
          breakpoints={{
            320: { slidesPerView: 2 },
            480: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 6 },
          }}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
        >
          {clientlogo.map((logo, index) => (
            <SwiperSlide key={index} className="home-brand-slide">
              <img src={logo.image} alt={`Brand ${index}`} className="home-brand-image" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Floating WhatsApp Icon */}
<div className="floating-whatsapp-container">
  <a
    href={`https://wa.me/${whatsappNumber}`}
    target="_blank"
    rel="noopener noreferrer"
    className="floating-whatsapp"
  >
    <FontAwesomeIcon icon={faWhatsapp} />
  </a>

  {isChatBoxVisible && (
    <div className="chat-box">
      <div className="wats-header">
        <p>Sun Pyro Kart</p>
        <button className="close-button" onClick={toggleChatBox}>
          X
        </button>
      </div>

      <div className="wats-content">
        <p>Welcome To Sun Pyro Kart</p>
      </div>

      <div className="chat-content">
        <textarea
          placeholder="Type your message here..."
          value={message}
          onChange={handleMessageChange}
        ></textarea>

        <button onClick={sendMessage}>
          <IoSendSharp />
        </button>
      </div>
    </div>
  )}
</div>

      <Scroll />
      <Footer />
      <MobileNavigation />
    </div>
  );
};

export default Home;